module.exports = __webpack_public_path__ + "img/15.06e402a6.png";